import React from 'react';
import ReactDOMServer from 'react-dom/server';
import PropTypes from 'prop-types';

import { PhotoSwipe } from 'react-photoswipe';
import 'react-photoswipe/lib/photoswipe.css';

import { getPhotoThumbUrl } from '../../../utils/Generic';
import { IMAGE_DIMENSIONS } from './PictureSlider';

import '../../../static/less/global/slider.less';
import '../../../static/css/slick.css';

const galleryOptions = {
  clickToCloseNonZoomable: false,
};

const testing = (src, width, height, caption) => (
  ReactDOMServer.renderToString(
    <figure className="mi-pswp__figure">
      <img src={src} width={width} height={height} />
      <figcaption>{caption}</figcaption>
    </figure>,
  )
);

const getPhotos = ({ photos, imageSize, roomName }) => {
  const { width, height } = IMAGE_DIMENSIONS[imageSize];
  return photos.map((photo) => {
    const src = getPhotoThumbUrl(photo.url, width, height);
    const caption = roomName.toLowerCase();
    return {
      barsSize: { top: 44, bottom: 44 },
      html: testing(src, width, height, caption),
    };
  });
};

const DoubleSlider = ({
  photos,
  imageSize,
  onClose,
  room,
  roomName,
}) => (
  <PhotoSwipe
    id={`gallery_${room.code}`}
    isOpen={true}
    items={getPhotos({ photos, imageSize, roomName })}
    options={galleryOptions}
    onClose={onClose}
  />
);

DoubleSlider.propTypes = {
  photos: PropTypes.array.isRequired,
  imageSize: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  room: PropTypes.object.isRequired,
  roomName: PropTypes.string.isRequired,
};

export default DoubleSlider;
